import React, { useState } from 'react'
import { useAlerts } from '@theneatcompany/nui'

import { Card, Text } from '@/components/common'
import Form from '@/components/forms/Form'
import InputField from '@/components/forms/InputField'
import Yup from '@/utils/yup'
import { extractMessage } from '@/utils/errors'

const schema = Yup.object({
  email: Yup.string().trim().lowercase().email()
    .required(),
})

const FORM_LINK = 'https://docs.google.com/forms/u/0/d/e/1FAIpQLScq9sZY506zKB5z52kgdxe9_dS5b2vFgGToACJjP_Xu8AbNaw/formResponse'

export default function MailingListOptOutForm() {
  const [succeeded, setSucceeded] = useState(false)
  const alerts = useAlerts()

  const handleSubmit = async (model) => {
    const formData = new FormData()
    const values = schema.cast(model)

    formData.append('entry.947555040', values.email)
    formData.append('entry.695378965', process.env.NEXT_PUBLIC_ENV)

    try {
      await fetch(`${FORM_LINK}`, {
        method: 'POST',
        mode: 'no-cors',
        body: formData,
      })

      setSucceeded(true)
    } catch (err) {
      alerts.error(extractMessage(err))
    }
  }

  return succeeded ? (
    <Card status="success">
      <Text.P messageId="pages.emailPreferences.unsubscribe.success" />
    </Card>
  ) : (
    <Form initialValues={{ email: '' }} onSubmit={handleSubmit} options={{ mode: 'all' }} schema={schema}>
      <InputField autoComplete="email" ignoreTouched={false} indicateValid labelProps={{ hidden: true }} name="email" />
      <Form.Action messageId="cta.unsubscribe" submittingMessageId="cta.processing" type="submit" variant="secondary" />
    </Form>
  )
}
